var showbox_nn = {
    name: "showbox nn",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [21,0,4,175,3,220,2,241,6,225,2,172,3,59,6,180,3,0,0,167,102,136],
        },
        {
            function: "KEY_POWERTV",
            name: "KEY_POWERTV",
            icon: "KEY_POWERTV",
            command: [19,0,5,153,3,233,2,225,6,76,6,161,3,74,6,229,6,243,2,146,3,0,0,137,214,132],
        },
        {
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [21,0,5,186,3,207,2,7,7,49,6,248,6,211,2,192,3,43,6,5,7,0,0,220,143,8],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [19,0,5,172,3,215,2,252,6,220,2,178,3,57,6,250,6,55,6,238,6,0,0,167,26,66],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [21,0,5,159,3,230,2,232,6,238,2,167,3,70,6,230,6,77,6,148,3,0,0,167,27,33],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [21,0,5,153,3,227,2,248,6,224,2,179,3,72,6,232,6,77,6,146,3,0,0,167,29,33],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [19,0,5,159,3,227,2,238,6,76,6,163,3,71,6,235,6,241,2,213,6,0,0,137,221,8],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [21,0,5,164,3,228,2,235,6,233,2,165,3,70,6,235,6,73,6,169,3,0,0,167,27,132],
        },
        {
            function: "KEY_TV",
            name: "KEY_TV",
            icon: "KEY_TV",
            command: [19,0,3,162,3,228,2,231,6,71,6,151,3,0,0,221,169],
        },
        {
            function: "KEY_EPG",
            name: "KEY_EPG",
            icon: "KEY_EPG",
            command: [19,0,3,155,3,230,2,231,6,76,6,237,6,0,0,221,178],
        },
        {
            function: "KEY_SETTING",
            name: "KEY_SETTING",
            icon: "KEY_SETTING",
            command: [21,0,5,155,3,231,2,229,6,77,6,237,6,241,2,162,3,72,6,165,3,0,0,221,145,132],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [19,0,5,161,3,233,2,224,6,237,2,165,3,71,6,230,6,76,6,215,6,0,0,199,74,66],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [21,0,4,156,3,233,2,224,6,236,2,166,3,71,6,168,3,0,0,167,74,98],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [18,0,4,157,3,232,2,229,6,79,6,235,6,232,2,173,3,72,6,220,142],
        },
        {
            function: "KEY_HOME",
            name: "KEY_HOME",
            icon: "KEY_HOME",
            command: [18,0,4,156,3,227,2,231,6,78,6,233,6,238,2,189,3,74,6,220,198],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [21,0,4,164,3,226,2,230,6,78,6,241,6,242,2,163,3,0,0,221,228,64],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [21,0,5,160,3,234,2,221,6,236,2,166,3,70,6,231,6,77,6,146,3,0,0,199,75,33],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [21,0,3,159,3,231,2,234,6,76,6,146,3,0,0,221,233],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [23,0,3,160,3,229,2,229,6,78,6,172,3,0,0,221,249],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [21,0,3,160,3,230,2,232,6,79,6,238,6,0,0,221,242],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [19,0,3,160,3,229,2,226,6,71,6,163,3,0,0,221,89],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [19,0,4,179,3,219,2,237,6,55,6,249,6,223,2,179,3,0,0,221,100,64],
        },
        {
            // function: "KEY_RETURN",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [23,0,5,189,3,201,2,0,7,52,6,9,7,206,2,196,3,44,6,196,3,0,0,220,199,132],
        },
        {
            function: "KEY_APP",
            name: "KEY_APP",
            icon: "KEY_APP",
            command: [21,0,4,191,3,201,2,11,7,32,6,7,7,210,2,193,3,0,0,221,204,64],
        },
        {
            function: "KEY_PIP",
            name: "KEY_PIP",
            icon: "KEY_PIP",
            command: [19,0,3,179,3,230,2,245,6,39,6,231,6,0,0,221,114],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [19,0,5,194,3,209,2,244,6,35,6,241,6,221,2,180,3,35,6,0,7,0,0,220,197,8],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [19,0,5,200,3,189,2,8,7,23,6,35,7,209,2,197,3,23,6,16,7,0,0,220,139,8],
        },
        {
            function: "KEY_PLAYPAUSE",
            name: "KEY_PLAYPAUSE",
            icon: "KEY_PLAYPAUSE",
            command: [21,0,5,160,3,230,2,231,6,73,6,229,6,245,2,163,3,57,6,161,3,0,0,220,197,132],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [21,0,5,168,3,226,2,232,6,233,2,242,6,64,6,171,3,65,6,167,3,0,0,206,139,132],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [20,0,3,182,3,210,2,1,7,51,6,0,7,215,2,220,248],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [21,0,5,190,3,202,2,8,7,45,6,5,7,213,2,200,3,41,6,243,6,0,0,220,241,8],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [23,0,5,161,3,234,2,235,6,58,6,229,6,248,2,156,3,53,6,154,3,0,0,220,241,132],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [21,0,5,161,3,234,2,221,6,242,2,231,6,68,6,167,3,66,6,154,3,0,0,206,226,132],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [21,0,5,158,3,238,2,222,6,79,6,223,6,239,2,157,3,65,6,146,3,0,0,220,226,132],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [21,0,5,191,3,204,2,5,7,45,6,5,7,211,2,187,3,44,6,7,7,0,0,220,227,8],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [23,0,5,159,3,230,2,234,6,81,6,236,6,237,2,163,3,77,6,161,3,0,0,220,227,132],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [21,0,5,160,3,229,2,230,6,238,2,245,6,80,6,169,3,73,6,156,3,0,0,206,197,132],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [21,0,5,154,3,233,2,232,6,246,2,159,3,75,6,231,6,80,6,142,3,0,0,199,101,33],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [23,0,4,186,3,211,2,225,6,51,6,226,6,236,2,221,3,0,0,220,252,64],
        },
        {
            function: "KEY_ASPECT",
            name: "KEY_ASPECT",
            icon: "KEY_ASPECT",
            command: [21,0,5,155,3,235,2,220,6,81,6,233,6,241,2,165,3,74,6,157,3,0,0,220,139,132],
        },
        {
            function: "KEY_KEYBOARD",
            name: "KEY_KEYBOARD",
            icon: "KEY_KEYBOARD",
            command: [21,0,5,154,3,234,2,230,6,241,2,233,6,81,6,164,3,77,6,160,3,0,0,206,141,132],
        },
    ]
}
export default showbox_nn